import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import avatar from './avatar.png'
import { makeRequestFormRequest } from '../../../utils';
import mainContext from '../../../contexts/mainContext';
import { __snackBarSeverity, __constants } from '../../../constants';
import { getEditBSProfile, saveUserProfile } from '../../../Controllers/EditProfile';
import Tags from '../../../common_components/Tags';
import moment from 'moment';
import { getCitiesListing, getAreasListing } from '../../../Controllers/ScopeManagement';

export function BabySitter({ setOpen, userId, cb }) {
    const { setSnackBar, setPageload } = React.useContext(mainContext);
    /* Maintain state */
    const [state, setState] = React.useState({
        userInfo: {},
        availableForBabyCare: [],
        interestedForBabyCare: [],
        specialityForBabyCare: [],
        childRangeExperience: [],
        iHaveForBabyCare: [],
        experience: [],
        languages: [],
        lngString: "",
        comfortableChild: 0,
        pic: null,
        rawImage: null
    })
    const [cities, setCities] = React.useState([])
    const [areas, setAreas] = React.useState([])
    const [filteredAreas, setFilteredAreas] = React.useState([])

    const formRef = React.useRef()

    React.useEffect(() => {
        async function getBSProfile() {
            const res = await getEditBSProfile(userId)
            if (res.status === 200) {
                let lang = ""
                res?.data?.userInfo?.languages[0]?.map((lng, index) => {
                    lang = lang + lng + (index < res?.data?.userInfo?.languages[0].length - 1 ? ", " : "")
                })
                setState({ ...state, ...res.data, comfortableChild: res?.data?.userInfo?.comfortableChild[0], lngString: lang, rawImage: __constants.images + res.data.userInfo?.profilePicture })
            } else {
                return callSnackBar(res.message, "error")
            }
            setPageload(false)
        }
        setPageload(true)
        /* Fetch Data */
        getCity()
        getArea()
        getBSProfile()
    }, [])

    React.useEffect(() => {
        if (areas.length > 0 && state.userInfo?.city) {
            const cityAreas = areas.filter(area => 
                area.cityId && area.cityId.city === state.userInfo.city
            );
            setFilteredAreas(cityAreas);
        }
    }, [areas, state.userInfo?.city]);

    /* Call snackbar */
    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const handleCityChange = (e) => {
        const selectedCity = e.target.value;
        
        // Filter areas based on selected city
        const cityAreas = areas.filter(area => 
            area.cityId && area.cityId.city === selectedCity
        );
        setFilteredAreas(cityAreas);
        
        // Update state with the new city
        setState({
            ...state,
            userInfo: {
                ...state.userInfo,
                city: selectedCity,
                area: '' // Reset area when city changes
            }
        });
    };

    const updateProfile = async (e) => {
        e.preventDefault()
        const request = makeRequestFormRequest(formRef)
        request.append('pic', state.pic)

        let experienceId,
            availableForBabyCareIds = [],
            interestedForBabyCareIds = [],
            IHaveForBabyCareIds = [],
            childRangeExperienceIds = [],
            specialityIds = []


        state.experience.some((obj) => {
            if (obj.isMarked) {
                experienceId = obj._id
                return true
            }
        })/* Config experience */

        state.availableForBabyCare.forEach((obj) => obj.isMarked && availableForBabyCareIds.push(obj._id))/* Config availableForIds */
        state.interestedForBabyCare.forEach((obj) => obj.isMarked && interestedForBabyCareIds.push(obj._id))/* Config interestedForIds */
        state.iHaveForBabyCare.forEach((obj) => obj.isMarked && IHaveForBabyCareIds.push(obj._id))/* Config availableForIds */
        state.childRangeExperience.forEach((obj) => obj.isMarked && childRangeExperienceIds.push(obj._id))/* Config interestedForIds */
        state.specialityForBabyCare.forEach((obj) => obj.isMarked && specialityIds.push(obj._id))/* Config availableForIds */

        if (availableForBabyCareIds.length === 0) {
            return callSnackBar("Please add atleast one 'available for'.", "error")
        }
        else if (interestedForBabyCareIds.length === 0) {
            return callSnackBar("Please add atleast one 'interested for'.", "error")
        }
        else if (IHaveForBabyCareIds.length === 0) {
            return callSnackBar("Please add atleast one 'I have'.", "error")
        }
        else if (childRangeExperienceIds.length === 0) {
            return callSnackBar("Please add atleast one 'child range experience'.", "error")
        }
        else if (specialityIds.length === 0) {
            return callSnackBar("Please add atleast one 'speciality'.", "error")
        }
        request.append("experienceId", experienceId)
        request.append("availableForBabyCareIds", availableForBabyCareIds)
        request.append("interestedForBabyCareIds", interestedForBabyCareIds)
        request.append("IHaveForBabyCareIds", IHaveForBabyCareIds)
        request.append("childRangeExperienceIds", childRangeExperienceIds)
        request.append("specialityIds", specialityIds)
        request.append("comfortableChild", state.comfortableChild)

        setPageload(true)
        const res = await saveUserProfile("BabySitter", userId, request)
        setPageload(false)
        /* Handle Api response */
        if (res.data.status === 200) {
            cb(res.data.data)
            setOpen(false)
            return callSnackBar(res.data.message, "success");
        } else {
            return callSnackBar(res.data.errors[0].message, "error");
        }
    }

    const handleSelection = (type, index) => {
        let temp;
        switch (type) {
            case "AvailableFor":
                temp = state.availableForBabyCare
                temp[index].isMarked = !temp[index].isMarked
                setState({ ...state, availableForBabyCare: temp })
                break;
            case "InterestedFor":
                temp = state.interestedForBabyCare
                temp[index].isMarked = !temp[index].isMarked
                setState({ ...state, interestedForBabyCare: temp })
                break;
            case "ChildExperience":
                temp = state.childRangeExperience
                temp[index].isMarked = !temp[index].isMarked
                setState({ ...state, childRangeExperience: temp })
                break;
            case "Experience":
                temp = state.experience
                temp.forEach((obj, i) => {
                    if (index !== i) {
                        temp[i].isMarked = false
                    }
                })
                temp[index].isMarked = true
                setState({ ...state, experience: temp })
                break;
            case "Speciality":
                temp = state.specialityForBabyCare
                temp[index].isMarked = !temp[index].isMarked
                setState({ ...state, specialityForBabyCare: temp })
                break;
            case "Ihave":
                temp = state.iHaveForBabyCare
                temp[index].isMarked = !temp[index].isMarked
                setState({ ...state, iHaveForBabyCare: temp })
                break;

        }

    }

    const getCity = async () => {
        const res = await getCitiesListing();
        if (res.data.status === 200) {
            setCities(res.data.data)
        }
    }

    const getArea = async () => {
        const res = await getAreasListing();
        if (res.data.status === 200) {
            setAreas(res.data.data)
        }
    }

    return (
        <Container>
            <Header>
                <h4>{state.userInfo?.firstName} {state.userInfo?.lastName} Edit profile</h4>
                <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
            </Header>

            <form ref={formRef} onSubmit={updateProfile}>
                <div className="image_handler">
                    <input type="file" id="picture" style={{ display: "none" }} onChange={(e) => { setState({ ...state, pic: e.target.files[0] }) }} />
                    <div className="img-box">
                        <label htmlFor="picture">
                            {state.pic ? <img className='img-frame' src={URL.createObjectURL(state.pic)} /> : state.rawImage && <img className='img-frame' onError={(e) => { setState({ ...state, rawImage: avatar }) }} src={state.rawImage} />}
                        </label>
                    </div>
                </div>
                {state?.userInfo?.status &&
                    <div className="form-box">
                        <label htmlFor="status">Status</label>
                        <select defaultValue={state?.userInfo?.status} name="status" id="status">
                            <option value="Sleeping">Sleeping</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>}
                <div className="form-box">
                    <label htmlFor="firstName">First name(*)</label>
                    <input required maxLength={40} id='firstName' type="text" className='input-box' defaultValue={state.userInfo?.firstName} />
                </div>
                <div className="form-box">
                    <label htmlFor="lastName">Last name(*)</label>
                    <input required maxLength={40} id='lastName' type="text" className='input-box' defaultValue={state.userInfo?.lastName} />
                </div>
                <div className="form-box">
                    <label className='c-text' htmlFor="email">Email(*)</label>
                    <input disabled id='email' type="text" className='input-box' defaultValue={state.userInfo?.email} />
                </div>
                <div className="form-box">
                    <label className='c-text' htmlFor="mobileNo">Mobile No(*)</label>
                    <input disabled id='mobileNo' type="text" className='input-box' defaultValue={state.userInfo?.mobileNo} />
                </div>
                <div className="form-box">
                    <label htmlFor="dateOfBirth">Date of birth(*)</label>
                    <input required max={moment().format("YYYY-MM-DD")} id='dateOfBirth' type="date" className='input-box' defaultValue={state.userInfo?.dateOfBirth} />
                </div>

                <div className="form-box">
                <label htmlFor="city">City</label>
                <select name="city" id="city" onChange={handleCityChange}>
                    <option value="">Select City</option>
                    {cities.map((data) => (
                    <option key={data._id} value={data.city} selected={data.city === state?.userInfo?.city}>
                        {data.city}
                    </option>
              ))}
                </select>
            </div>

                <div className="form-box">
                <label htmlFor="area">Area</label>
                <select 
                    name="area" 
                    id="area" 
                    onChange={(e) => setState({ ...state, userInfo: { ...state.userInfo, area: e.target.value } })}
                >
                    <option value="">Select Area</option>
                    {filteredAreas.map((data) => (
                    <option key={data._id} value={data.area} selected={data.area === state?.userInfo?.area}>
                        {data.area}
                     </option>
                    ))}
                </select>
                </div>
                {/* <div className="form-box">
                    <label htmlFor="address">Address(*)</label>
                    <textarea required maxLength={150} id='address' type="text" className='input-box' style={{ height: 'initial' }} rows={4} defaultValue={state.userInfo?.address} />
                </div> */}
                <div className="form-box">
                    <label htmlFor="aboutMe">About(*)</label>
                    <textarea required maxLength={400} id='aboutMe' type="text" className='input-box' style={{ height: 'initial' }} rows={7} defaultValue={state.userInfo?.aboutMe} />
                </div>
                <section className='seeker-profile'>
                    <div className='sec'>
                        <p className='labels'>Years of experience(*)</p>
                        {state.experience.map((exp, index) =>
                            <Tags
                                key={exp._id}
                                onClick={() => handleSelection("Experience", index)}
                                title={exp.from + "-" + exp.to}
                                isActive={exp.isMarked}
                            />
                        )}
                    </div>
                    <div className='sec'>
                        <p className='labels'>Child range experience(*)</p>
                        {state.childRangeExperience.map((exp, index) =>
                            <Tags
                                key={exp._id}
                                onClick={() => handleSelection("ChildExperience", index)}
                                title={exp.name}
                                isActive={exp.isMarked}
                            />
                        )}
                    </div>
                    <div className="form-box">
                        <p className='labels'>Speaks(*)</p>
                        {state.userInfo && <input required id='languages' className='input-box' defaultValue={state.lngString} onChange={(e) => setState({ ...state, lngString: e.target.value })} />}
                    </div>
                    <div className='sec'>
                    </div>
                    <div className='sec'>
                        <p className='labels'>Has(*)</p>
                        {state.iHaveForBabyCare.map((obj, index) =>
                            <Tags
                                key={obj._id}
                                onClick={() => handleSelection("Ihave", index)}
                                title={obj.name}
                                isActive={obj.isMarked}
                            />
                        )}
                    </div>
                    <div className='sec'>
                        <p className='labels'>Available for(*)</p>
                        {state.availableForBabyCare.map((obj, index) =>
                            <Tags
                                key={obj._id}
                                onClick={() => handleSelection("AvailableFor", index)}
                                title={obj.name}
                                isActive={obj.isMarked}
                            />
                        )}
                    </div>

                    <div className='sec'>
                        <p className='labels'>Happy to help with(*)</p>
                        {state.interestedForBabyCare.map((obj, index) =>
                            <Tags
                                key={obj._id}
                                onClick={() => handleSelection("InterestedFor", index)}
                                title={obj.name}
                                isActive={obj.isMarked}
                            />
                        )}
                    </div>
                    <div className='sec'>
                        <p className='labels'>Comfortable to babysit(*)</p>
                        {[1, 2, 3].map((val) =>
                            <Tags
                                key={val}
                                onClick={() => setState({ ...state, comfortableChild: val })}
                                title={val}
                                isActive={state.comfortableChild === val}
                            />
                        )}
                    </div>
                    <div className='sec'>
                        <p className='labels'>Specialties(*)</p>
                        {state.specialityForBabyCare.map((obj, index) =>
                            <Tags
                                key={obj._id}
                                onClick={() => handleSelection("Speciality", index)}
                                title={obj.name}
                                isActive={obj.isMarked}
                            />
                        )}
                    </div>
                    <div className="sec">
                        <p className='labels'>Hourly rate(*)</p>
                        {state.userInfo?.hourlyRateForOneOrTwoChild && <div className="inline-flex-bx">
                            <label htmlFor="hourlyRateForOneOrTwoChild">1 or 2 child</label>
                            <div>
                                <input id='hourlyRateForOneOrTwoChild' name="hourlyRateForOneOrTwoChild" type="text" className='input-box' defaultValue={state.userInfo?.hourlyRateForOneOrTwoChild?.length > 0 ? state.userInfo?.hourlyRateForOneOrTwoChild[0] : 0} />
                                <span>$/h</span>
                            </div>
                        </div>}
                        {state.userInfo?.hourlyRateForThreeChild &&
                            <div className="inline-flex-bx">
                                <label htmlFor="hourlyRateForThreeChild">3 child</label>
                                <div>
                                    <input id='hourlyRateForThreeChild' name="hourlyRateForThreeChild" type="text" className='input-box' defaultValue={state.userInfo?.hourlyRateForThreeChild?.length > 0 ? state.userInfo?.hourlyRateForThreeChild[0] : 0} />
                                    <span>$/h</span>
                                </div>
                            </div>}
                    </div>

                    <div className="sec">
                        <p className='labels'>Overnight rate(*)</p>
                        {state.userInfo?.overnightRate && <div className="inline-flex-bx">
                            <label htmlFor="overnightRate">Overnight rate</label>
                            <div>
                                <input id='overnightRate' name="overnightRate" type="text" className='input-box' defaultValue={state.userInfo?.overnightRate?.length > 0 ? state.userInfo?.overnightRate[0] : 0} />
                                <span>$/h</span>
                            </div>
                        </div>}

                    </div>
                </section>

                <Button variant='outlined' type='submit'>Update</Button>
            </form>
        </Container>
    )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    padding: 1rem;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    .divider-gap{
        margin: 0.5rem 0;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
      display: flex;
      font-family: 'semi-bold'
    }
    .chip{
        width: fit-content;
        background-color: var(--nona-light-blue);
    }
    .image_handler{
        padding:20px 0;
        margin-bottom:20px;
        border-radius : 300px 50px;
    }
    .img-box{
        margin: 0px auto;
    }
    .img-box img{
        display:block;
        margin: 0px auto;
        width:120px;
        height:120px;  
        border-radius:100%;
        // clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
    }
    form{
        display: flex;
        flex-direction: column;
        padding: 1rem;
        overflow: auto;
    }
    .form-box{
        margin-bottom:15px;
    }
    .form-box label{
        display:block;
        font-size : 14px;
        color : var(--theme-color);
        margin-bottom:0px;
    }
    .form-box .input-box{
        height:25px;
        width:100%;
        border:none;
        padding:2px 0px;
        outline : none;
        border-bottom:2px solid var(--card-border);
        display:block;
        font-size : 16px;
    }
    .form-box .input-box:focus{
        border-bottom:2px solid var(--theme-color);
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;



